import { useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 fill-current" aria-hidden="true">
    <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.7a2.8 2.8 0 0 0 1.8-1.3 2.3 2.3 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3Z" />
  </svg>
);

export function WhatsAppTopBar() {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  const num = String(settings.vip_whatsapp || "918838576060").replace(/\D/g, "");
  const slug = (pathname.match(/-chart-record\/([^/]+)/) || [])[1];
  const market = slug ? decodeURIComponent(slug).replace(/-/g, " ").toUpperCase() : "";
  const text = `AVADHESH SIR — ${market ? `${market} game chahiye` : "VIP game chahiye"}`;
  return (
    <a data-testid="whatsapp-top-bar" href={`https://wa.me/${num}?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer"
      className="notranslate flex items-center justify-center gap-2 bg-[#25D366] px-3 py-1.5 text-center text-[12px] font-extrabold text-white transition-colors hover:bg-[#1EBE5A] sm:text-sm" translate="no">
      <WaIcon />
      <span>Avadhesh Sir se VIP game lene ke liye WhatsApp karein</span>
      <span className="hidden rounded-full bg-white px-2 py-[1px] text-[11px] text-[#128C7E] sm:inline">+{num}</span>
    </a>
  );
}
